import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, Redirect, matchPath, useLocation } from 'react-router-dom';
// import { TourProvider } from '@reactour/tour';
import { routes as originRoutes } from './routes';

import { SideNavigation } from '@app/components';

import { isLoggedInSelector, isSuperAdminSelector, networkRoleSelector, showTutorialSelector } from '@app/store/session/selector';
import { WelcomeModal } from '@app/components/modals';
import { NETWORK_ADMIN_ROLE, NETWORK_MANAGER_ROLE } from '@app/../shared/constants';
// import { MEMBER_ROLE, NETWORK_ADMIN_ROLE, NETWORK_MANAGER_ROLE } from '@app/../shared/constants';
// import steps from '../tour/steps';
// const maskRadius = 10;
export default function Dashboard() {
  const loggedIn = useSelector(isLoggedInSelector);
  const isSuperAdmin = useSelector(isSuperAdminSelector);
  const role = useSelector(networkRoleSelector);
  const showTutorial = useSelector(showTutorialSelector);
  const [openWelcome, setOpenWelcome] = useState(!isSuperAdmin && showTutorial);
  const { pathname } = useLocation();
  const routes = originRoutes.filter((route) => isSuperAdmin || route.permission?.includes(role));
  const activePath = routes.find((route) => matchPath(pathname, route));

  if (!loggedIn) {
    return <Redirect to="/login" />;
  }

  // <TourProvider
  //   steps={steps}
  //   padding={{ mask: [10, 2], popover: 4, wrapper: 0 }}
  //   position="right"
  //   showBadge={false}
  //   showNavigation={false}
  //   showCloseButton={false}
  //   disableInteraction={true}
  //   maskClassName="opacity-80"
  //   styles={{
  //     popover: (base) => ({
  //       ...base,
  //       borderRadius: maskRadius,
  //     }),
  //     maskArea: (base) => ({ ...base, rx: maskRadius }),
  //   }}
  //   onClickMask={() => {}}
  //   className="bg-transparent shadow-none max-w-none h-4 flex -top-2">

  // {role === MEMBER_ROLE && <Redirect from="/networks/:id/members" to="/networks/:id/billing" />}
  return (
    <div className="flex flex-row flex-1 h-full" id="dashbaord">
      <SideNavigation activePath={activePath && activePath.key} />
      <div className="flex-1 h-full w-full overflow-y-auto bg-main overflow-x-auto">
        <Switch>
          {routes.map((route, index) => (
            <Route key={index} {...route} />
          ))}
          {isSuperAdmin && <Redirect to="/networks" />}
          {role === NETWORK_ADMIN_ROLE && <Redirect from="/networks/:id" to="/networks/:id/members" />}
          {role === NETWORK_MANAGER_ROLE && <Redirect from="/networks/:id" to="/networks/:id/pending-posts" />}
          {role === NETWORK_MANAGER_ROLE && <Redirect from="/networks/:id/members" to="/networks/:id/pending-posts" />}
        </Switch>
      </div>
      <WelcomeModal isOpen={openWelcome} onClose={() => setOpenWelcome(false)} />
    </div>
  );
}
